module.exports = __webpack_public_path__ + "img/1620746689.006320fa.jpg";